import i18n from '../i18n';

export const tField = (field, lang) => {
  try {
    if (!field) return '';
    if (typeof field === 'string') return field; 
    
    // Read from localStorage to avoid i18n staleness during React renders
    const storedLang = typeof window !== 'undefined' ? localStorage.getItem('ets_lang') : null;
    const safeLang = lang || storedLang || (i18n && i18n.language) || 'en';
    const targetLang = safeLang.startsWith('zh') ? 'zh' : 'en';
    const fallbackLang = targetLang === 'en' ? 'zh' : 'en';

    if (field[targetLang]) {
      if (Array.isArray(field[targetLang])) return field[targetLang].join(' • ');
      return String(field[targetLang]);
    }
    if (field[fallbackLang]) {
      if (Array.isArray(field[fallbackLang])) return field[fallbackLang].join(' • ');
      return String(field[fallbackLang]);
    }
    return '';
  } catch (err) {
    return '';
  }
};
